import environment from '../../../../environments/environment';

export function avatarInitials(name: string) {
    if (name.toLowerCase() === name) {
        name = name.toLowerCase().split(' ').map((p) => {
            return p.charAt(0).toUpperCase() + p.slice(1);
        }).join(' ');
    }

    const parts = name.split(' ').map((p) => {
        // includes middle initials
        if (p === p.toUpperCase() && (p.length > 1 && p.charAt(1) !== '.')) {
            return [p.charAt(0)];
        }

        return p.split(/(?=[A-Z\-])/).filter((n, i, arr) => {
            // ignore suffixes and special characters
            if ('Inc.Jr.Sr.&-'.indexOf(n) > -1) {
                return false;
            }

            // ignore second-half of hyphenated name
            if (arr[i - 1] && arr[i - 1].charAt(0) === '-') {
                return false;
            }

            const initial = n.charAt(0);
            return (!isNaN(+initial) || initial === initial.toUpperCase());
        });
    });

    const flattened = parts.reduce((a, b) => a.concat(b), []);
    if (flattened.length === 0) {
        // unable to establish initials based on given name
        return '--';
    }

    return flattened[0].charAt(0) + (flattened[1] ? flattened[1].charAt(0) : '');
}

export class BaseAvatar {
    name: string;

    // profile picture for user
    userId: number;

    profileImagePath: string;
    profileImage: string;

    constructor(protected data: { [prop: string]: any }) {
        if (data.name) {
            this.name = data.name;
        }

        if (data.userId) {
            this.userId = data.userId;
            this.validateProfileImage(`${environment.S3URL + environment.UserProfileBucket}/${this.userId}/profile-150.png`);
        }
    }

    get initials(): string {
        return avatarInitials(this.name);
    }

    private validateProfileImage(path: string) {
        if (!path) {
            return null;
        }

        const img = new Image();

        img.onload = () => {
            this.profileImage = `${path}?nocache=${new Date().getTime()}`;
        };

        img.onerror = () => {
            this.profileImage = null;
        };

        img.src = path;
    }
}
